import { setPropertiesToRC } from '../utils/setPropertiesToRC.js';
import TiRadio$1 from './Radio/index.js';
import RadioGroup from './RadioGroup/index.js';

var TiRadio = setPropertiesToRC(TiRadio$1, {
  Group: RadioGroup
});

export { TiRadio };
